import React from 'react'

const CoreComponent25 = ({header}) => {
  return (
    <div>
           <div className="row d-flex justify-content-evenly ">
            {header.map((val, i) => (
              <div key={i} className="col-lg-3 col-6 mb-4">
                <div className="bg-light shadow p-3">
                  <h3 className="fs-4 font-gordita h3-heading text-center "> {val.num}</h3>
                  <h4 className="fs-5 mt-2 h3-para text-center ">{val.title}</h4>
                </div>
              </div>
            ))}
          </div>
    </div>
  )
}

export default CoreComponent25